module.exports = __webpack_public_path__ + "img/table_header_bg.68726974.png";